import { useState, useEffect } from 'react';
import getConfluencePageHtml from '../functions/getConfluencePageHtml';

const useConfluencePage = ({ pageName, hasAccess }) => {
  const [html, setHtml] = useState();
  const [pageTitle, setPageTitle] = useState();
  const [id, setId] = useState();
  const [loading, setLoading] = useState(false);
  const [pageEditLink, setPageEditLink] = useState();

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      const { html: pageHtml, title, pageId, editLink } = await getConfluencePageHtml(
        pageName
      );
      setHtml(pageHtml);
      setPageTitle(title);
      setId(pageId);
      setPageEditLink(editLink)
      setLoading(false);
    };
    if (hasAccess) {
      fetch();
    }
  }, [pageName, hasAccess]);

  return {
    html,
    pageTitle,
    id,
    pageEditLink,
    loading,
  };
};

export default useConfluencePage;
